// extracted by mini-css-extract-plugin
export default {"action":"Retention_action__+9Mjj"};